export const colorsChart: any = [
  '#4E69CB',
  '#7CB9B9',
  '#69A47B',
  '#DFCF90',
  '#CC7D7D',
  '#4E96CB',
  '#CC7DC9',
  '#7CA469',
  '#CC9E7D',
  '#764ECB',
  '#A97DCC',
  '#69A496',
  '#9C4E43',
  '#7C89B9'
]

export const colorsChartChrome: any = [
  '#C4C4C4',
  '#ababab',
  '#d9d9d9',
]
